export { default as NMention, mentionProps } from './src/Mention';
